import { IComponentOptions, IController, IFormController, IPromise } from 'angular';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { IRawRole } from '../../../../core/services/role/role.interfaces';
import { EmployerRegData } from '../../models/employer-reg-data';
import { $Event } from '../../../../helpers';
import { CountryService } from '../../../../core/services/country/country-service';
import { NAME_REGEXP, PASSWORD_REGEXP } from '../../../../helpers/validators';
import { TransitionBarService } from '../../../../ui/transition-bar/transition-bar.service';
import './employer-registration-form.component.scss';
import { ToastrService } from '../../../../core/services/toastr/toastr.service';

export class EmployerRegistrationFormController implements IController {
  static $inject = [
    'AuthService',
    'CountryService',
    'TransitionBarService',
    'ToastrService'
  ];
  REG_DETAILS_MAX_COUNT = 10;
  registered: ( $event ) => void;
  data = new EmployerRegData();
  form: IFormController;
  termsAccepted = false;
  conditionsAccepted = false;
  passwordPattern = PASSWORD_REGEXP;
  namePattern = NAME_REGEXP;
  serverError;
  loading = false;
  checkboxError = {
    privacy: false,
    terms: false
  };

  constructor( private authService: AuthService,
               private countryService: CountryService,
               private transitionBarService: TransitionBarService,
               private toastrService: ToastrService ) {
  }

  $onInit() {

  }

  set parentId( id ) {
    this.data.parent_id = id;
  }

  set userRole( role: IRawRole ) {
    this.data.role = role.id;
  }

  loadCountries(): IPromise<string[]> {
    return this.countryService.getCountries();
  }

  loadCities(): IPromise<string[]> {
    return this.countryService.getCitiesByCountry(this.data.personal_data.country || '');
  }

  onCountryChange() {
    this.data.personal_data.city = '';
  }

  addField( fieldName: string ) {
    const fieldSelector = '.' + fieldName + '-reg';
    const fieldCount = document.querySelectorAll(fieldSelector).length;
    if (fieldCount < this.REG_DETAILS_MAX_COUNT) {
        this.data.personal_data[fieldName].push({});
    }
  }

  removeField( fieldName: string, index: number ) {
    this.data.personal_data[ fieldName ].splice(index, 1);
  }

  addCompanyField( fieldName: string ) {
      const fieldSelector = '.' + fieldName + '-employer-reg';
      const fieldCount = document.querySelectorAll(fieldSelector).length;
      if (fieldCount < this.REG_DETAILS_MAX_COUNT) {
          this.data.company_data[ fieldName ].push('');
      }
  }

  removeCompanyField( fieldName: string, index: number ) {
    this.data.company_data[ fieldName ].splice(index, 1);
  }

  checked() {
    this.checkboxError = {
      privacy: !this.conditionsAccepted,
      terms: !this.termsAccepted,
    };
  }

  submit() {
    this.serverError = '';
    this.checkboxError = {
      privacy: !this.conditionsAccepted,
      terms: !this.termsAccepted,
    };
    if ( this.form.$invalid ) {
      return;
    }
    if ( !this.termsAccepted || !this.conditionsAccepted ) {
      this.toastrService.error('You need to accept Privacy policy, Terms and Conditions');
      return;
    }
    this.loading = true;
    this.transitionBarService.barActive(true);
    this.data.accept_private_policy = this.conditionsAccepted;
    this.data.accept_terms_and_conditions = this.termsAccepted;
    this.data.personal_data.username = this.data.personal_data.personal_email[ 0 ].value;
    this.authService.register(this.data)
      .then(() => {
        this.registered(new $Event({ data: this.data }));
      })
      .catch(( err ) => {
        console.log(err);
        this.serverError = err;
      })
      .finally(() => {
        this.transitionBarService.barActive(false);
        this.loading = false;
      });
  }
}

export const EmployerRegistrationFormComponent: IComponentOptions = {
  controller: EmployerRegistrationFormController,
  template: require('./employer-registration-form.component.html'),
  bindings: {
    userRole: '<',
    parentId: '<',
    registered: '&'
  }
};



// WEBPACK FOOTER //
// ./app/states/auth/components/employer-registration-form/employer-registration-form.component.ts